
  import React from 'react';
  import COMPONENTS from '../../components';
  import { get } from 'lodash';
  import PageLayout from '../../layout';
  import { graphql } from 'gatsby';

  class Page extends React.Component {
    state = {
      data: [],
    };

    componentDidMount() {
      let slices;

      const data = get(this, 'props.data.careersJson');

      if (data) {
        slices = Object.entries(data).map(([key, content]) => ({
          componentName: key,
          ...content,
        }));

        slices.sort(
          ({ position: positionA }, { position: positionB }) =>
            positionA - positionB
        );

        this.setState({
          data: slices,
        });
      }
    }

    render() {
      return (
        <PageLayout>
          {get(this, 'state.data').map(({ componentName, data }, index) => {
            const ComponentType = COMPONENTS[componentName];
            return <ComponentType key={index} {...data} />;
          })}
        </PageLayout>
      );
    }
  }

  export default Page;

  export const pageQuery = graphql`
    query {
      careersJson {
        
      
      
      
      
      
      
      
      
      
      
      CTAWith2Buttons0 {
        position
        componentName
        data {
           title description buttonDark {  text link } buttonLight {  text link }
        }
      }
    
      BannerMask1 {
        position
        componentName
        data {
           media {  type src } corners height
        }
      }
    
      Divider2 {
        position
        componentName
        data {
           height
        }
      }
    
      Testimonial3 {
        position
        componentName
        data {
           title statements {  title text } quotationText quotationByline1 quotationByline2
        }
      }
    
      ProductSingle4 {
        position
        componentName
        data {
           title textBody image
        }
      }
    
      CTA5 {
        position
        componentName
        data {
           title textBody button {  text link }
        }
      }
    
      Divider6 {
        position
        componentName
        data {
           height backgroundColor
        }
      }
    
      Header7 {
        position
        componentName
        data {
           title type subtitle showRedLine
        }
      }
    
      Divider8 {
        position
        componentName
        data {
           height backgroundColor
        }
      }
    
      CTAPhoto9 {
        position
        componentName
        data {
           image title textBody button {  text link }
        }
      }
    
      }
    }
  `